export default __webpack_public_path__ + "static/media/t2Sala2.b0672b0d.jpg";